import {
  ApiResponse,
  LayerDefinition,
  LayerSchemaConfig,
  LayerStyles,
} from '@packages/database/types';
import api from './client/axios';

interface AssetFilters {
  bbox?: number[];
  assetType?: string;
  limit?: number;
}

export const getMapLayerConfigs = async () => {
  const response =
    await api.get<ApiResponse<LayerDefinition[]>>('/layers/config');
  return response.data.data;
};

export const getLayerFeatures = async (layerId: string): Promise<any> => {
  const response = await api.get(`/layers/${layerId}/features`);
  return response.data.data;
};

export const getServiceAreasLayer = async (): Promise<any> => {
  const response = await api.get('/layers/service-areas');
  return response.data.data;
};
export const getPremisesLayer = async (): Promise<any> => {
  const response = await api.get('/layers/premises');
  return response.data.data;
};

export const getFieldNotesLayer = async (): Promise<any> => {
  const response = await api.get('/layers/field-notes');
  return response.data.data;
};

export const updateLayerConfig = async (
  layerId: string,
  input: { styles?: LayerStyles; schemaConfig?: LayerSchemaConfig },
) => {
  const response = await api.patch<ApiResponse<LayerDefinition>>(
    `/layers/${layerId}/config`,
    input,
  );
  return response.data.data;
};
